import React, { useRef } from 'react';
import { __ } from '@wordpress/i18n';

// store
//import { storeSet, storeGet } from '../../store';

// service


// tools


// components
import { Toast } from 'primereact/toast';
import ListCompaniesTable from './components/ListCompaniesTable';
import DialogInviteSupplier from './components/DialogInviteSupplier';
import DownloadSuppliersCsv from './components/DownloadSuppliersCsv';

const ManageSuppliers = () => {
    const toast = useRef(null);

    return (
        <div className="appPage">
            <div className="appPage__pageHeader">
                <h1>{__('Gestione fornitori', 'htr')}</h1>
            </div>

            <div className="appPage__spacer"></div>
            <Toast ref={toast}/>

            <div className="appPageSection">
                <div className="appPageSection__actions">
                    <DialogInviteSupplier/>
                    <DownloadSuppliersCsv/>
                </div>
            </div>

            <div className="appPage__spacer"></div>

            <div className="appPageSection">
                <ListCompaniesTable/>
            </div>
        </div>
    )
}

export default ManageSuppliers;